module.exports = __webpack_public_path__ + "img/fireworks-back-blur.0c8caac8.jpg";